<template>
  <v-alert v-if="error"
           id="section-alert"
           type="info"
           prominent
           color="red darken-4"
           class="flex-grow-1 text-caption text-sm-body-1 pt-1 mt-4 pt-sm-2"
  >
    <div v-if="text1" v-text="text1" />
    <div v-if="text2" v-text="text2" />
  </v-alert>
</template>

<script>
export default {
  name: 'AlertTimeRange',
  props: {
    point: { type: [Number, String], default: null },
  },
  computed: {
    text1() {
      const { order_text_off, order_delivery_off } = this.$store.state.data.settings;
      switch (this.error) {
        case 'order': return order_text_off || this.$dictionary.get('cannot-order');
        case 'delivery': return order_delivery_off || this.$dictionary.get('cannot-deliver');
        default: return null;
      }
    },
    text2() {
      if (!this.pointData) return null;
      switch (this.error) {
        case 'order': return this.$tools.time.range(
          this.pointData.order_time_range[0],
          this.pointData.order_time_range[1]
        );
        case 'delivery': return this.$tools.time.range(
          this.pointData.delivery_time_range[0],
          this.pointData.delivery_time_range[1]
        );
        default: return null;
      }
    },
    pointData() {
      if (this.point === null) return null;
      const { points } = this.$store.state.data;
      if (!points) return null;
      return points[this.point];
    },
    error() {
      const { settings } = this.$store.state.data;
      if (!this.pointData || settings.readonly) return null;
      if (!this.pointData.order_time_ok) return 'order';
      if (!this.pointData.delivery_time_ok) return 'delivery';
      return null;
    },
  },
};
</script>
